import { ArrowLeftRight, LockKeyhole, MoveUp } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Page } from '@app/routes';
import { creditCardIcon } from '@app/assets';

const WithdrawalIcon = () => (
  <div className="mx-auto flex size-7 items-center justify-center rounded-full bg-accent">
    <MoveUp color="white" size="16" />
  </div>
);

const TransferIcon = () => (
  <div className="mx-auto flex size-7 items-center justify-center rounded-full bg-accent">
    <ArrowLeftRight color="white" size="16" />
  </div>
);

const EnteringIcon = () => (
  <img src={creditCardIcon} alt="credit-card" className="mx-auto size-8" />
);

interface ActionProps {
  type: 'withdrawal' | 'transfer' | 'deposit';
}

const ACTIONS = {
  withdrawal: {
    title: 'bank.withdrawal',
    icon: WithdrawalIcon,
    route: Page.WITHDRAWAL,
    isLocked: false,
  },
  transfer: { title: 'bank.transfer', icon: TransferIcon, route: '', isLocked: true },
  deposit: {
    title: 'bank.deposit',
    icon: EnteringIcon,
    route: Page.SETTLEMENTS_SHOP,
    isLocked: false,
  },
};

export function Action({ type }: ActionProps) {
  const { t } = useTranslation();
  const action = ACTIONS[type];
  const Icon = action.icon;

  return (
    <Link
      to={action.route}
      className="flex h-[56px] flex-col justify-between rounded-lg text-[11px] font-semibold text-accent hover:text-accent/90 hover:underline"
    >
      <Icon />
      <div className="flex items-center gap-1">
        {t(action.title)} {action.isLocked && <LockKeyhole size="12" />}
      </div>
    </Link>
  );
}
